import { Lesson } from "@jelly/lesson";
import config from "appConfig";
import { task as task01 } from "../../../task/course-04/lesson-01/task-01";
import theory from "./theory";

const lesson: Lesson = {
  id: "5571c169-9a0c-4065-81f7-dce9a08e928c",
  publicId: "1",
  name: "Signal processing of sound by humans (Signal Processing of human Hearing)",
  difficulty: 1,
  contentTypes: { audio: false, interactive: false, video: true },

  body: [
    {
      title: "",
      description: "Different steps of the electrocoustical transduction are detailed in this video.",
      theory: theory,
      layout: {
        type: "simple",
        options: {
          components: {
            variant: "blockContainer",
            data: {
              block: {
                type: "video",
                options: {
                  src: `${config.ASSETS_URL}/04/01/principle/video.mp4`,
                  poster: `${config.ASSETS_URL}/04/01/principle/video-poster.svg`,
                },
              },
              styles: {
                padding: "3% 12.9%",
              },
            },
          },
        },
      },
    },
    {
      titleHtml:
        "For each transducer shown on a picture, connect the input domain to the output domain.<br>Hint: Always connect it to the final signal domain, disregard the intermediate conversion.",
      description: "Connect with lines.",
      layout: {
        type: "simple",
        options: {
          components: {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        },
      },
    },
  ],
};

export default lesson;
